export default "__VITE_ASSET__7f839650__"